export default {

	// a random token in the geekgroup unambiguous alphabet (no 0/1/i/l/o)
	token: function(length) {

		var alphabet = 'abcdefghjkmnpqrstuvwxyz23456789'
		var token = ''

		for (var i = 0; i < (length || 16); i++) {

			token += alphabet.charAt(Math.floor(Math.random() * alphabet.length))

		}

		return token

	}

}
